var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnpin(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.218 2.295a.5.5 0 00-.477.184l-.432.551a.5.5 0 00.084.702l5.235 4.106-.06.793a5.25 5.25 0 00-2.484 2.96l-.031.093A1 1 0 005.003 13h8.207l3.92 3.075a.5.5 0 00.702-.085l.432-.55a.5.5 0 00-.084-.702l-.527-.413a.497.497 0 01-.225-.1L2.218 2.295zm12.215 7.04a5.285 5.285 0 00-.529-.416l.53.415zm-1.006-.79L13.077 4H14c.553 0 1-.447 1-1 0-.553-.447-1-1-1H6.002c-.24 0-.46.084-.633.225l8.058 6.32zM9 14H11v3a.999.999 0 11-2 0v-3z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default ForwardRef;